import ProductHighlight from "./ProductHighlight.vue";
Vue.component("product-highlight", ProductHighlight);
